/**
 * @param Options
 * type session|local
 * expire Int seconds
 * key String
 * Value Any
 */
App.namespace.wrap('es6.shared.temporary_storage_manager', ({ type = 'local', expire, key } = {}) => {
  const storageManager = App.es6.shared.storage_manager().init(type);

  if (!key) {
    throw new Error('Key is required');
  }

  const isNotExpired = (dateToCheck) => {
    return ((new Date()) - (new Date(dateToCheck))) < expire * 1000;
  };

  const set = (data) => {
    const savedAt = new Date();
    return storageManager.set(key, JSON.stringify({ data, savedAt }));
  };

  const get = () => {
    if (!expire) {
      throw new Error('Expire is required with get');
    }
    const formData = storageManager.get(key);
    if (formData) {
      const { data, savedAt } = JSON.parse(formData);
      if (data && isNotExpired(savedAt)) {
        return data;
      }

      storageManager.remove(key);
    }
    return null;
  };

  return {
    get,
    set,
  };
});
